/*=====================================
    最新消息 - 所屬遊戲篩選視窗

    createtime: 2026 / 08 / 13
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DialogStyle, Colors } from 'stylecomponents';

/*--------------------------
    Styled
--------------------------*/
const Title = styled.h6`
    line-height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #565151;
    text-align: center;
    margin: 0 0 12px 0;
`;

const List = styled.div`
    max-height: 50vh;
    overflow-y: auto;
`;

const ListItem = styled.div`
    padding: 12px 8px;
    font-size: 15px;
    text-align: center;
    color: ${props => props.highlight ? Colors.Orange : Colors.Dark3};
    cursor: pointer;

    &:not(:last-child) {
        border-bottom: solid 1px #EFEFEF;
    }
`;

/*--------------------------
    Main Component
--------------------------*/
const NewsGameFilterDialog = ({
    visible,
    games,
    selectedGameId,
    onSelect,
    onClose,
}) => {

    return (
        <DialogStyle.Content
            width="calc(100% - 40px)"
            maxWidth="320px"
            padding="20px"
            backgroundColor="#fff"
            borderRadius="3px"
            visible={visible}
            animation="zoom"
            maskAnimation="fade"
            closable={false}
            maskClosable={true}
            keyboard={false}
            onClose={onClose}
        >
            <DialogStyle.CloseButton onClick={onClose}>
                <i className="zmdi zmdi-close"></i>
            </DialogStyle.CloseButton>
            <Title>所屬遊戲</Title>
            <List>
                <ListItem
                    highlight={!selectedGameId}
                    onClick={() => onSelect(0)}
                >
                    全部遊戲
                </ListItem>
                {games.map(game => (
                    <ListItem
                        key={game.gameid}
                        highlight={selectedGameId === game.gameid}
                        onClick={() => onSelect(game.gameid)}
                    >
                        {game.gamename}
                    </ListItem>
                ))}
            </List>
        </DialogStyle.Content>
    );
};

NewsGameFilterDialog.propTypes = {
    visible: PropTypes.bool.isRequired,
    games: PropTypes.array,
    selectedGameId: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

NewsGameFilterDialog.defaultProps = {
    games: [],
};

/*--------------------------
    export
--------------------------*/
export default NewsGameFilterDialog;
